import { useState } from 'react'
import { Box, Divider, Drawer, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ManageHistoryIcon from '@mui/icons-material/ManageHistory'
import { com } from '@eidu/web'
import useHasGlobalPermissions from '../permission/useHasGlobalPermissions'
import AuditHistoryTab from './AuditHistoryTab'
import GlobalAction = com.eidu.sharedlib.entity.permission.GlobalAction

type Props = {
  targetId: string
}

const DRAWER_WIDTH = 720

const AuditLogDrawer = ({ targetId }: Props) => {
  const [open, setOpen] = useState(false)
  const { hasPermission, loading } = useHasGlobalPermissions(GlobalAction.ViewAuditLog)
  if (loading || !hasPermission(GlobalAction.ViewAuditLog)) return null

  return (
    <>
      <Tooltip title="Audit log">
        <IconButton onClick={() => setOpen(true)} aria-label="Open audit log" data-testid="audit-log-open">
          <ManageHistoryIcon />
        </IconButton>
      </Tooltip>
      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
        PaperProps={{ sx: { width: DRAWER_WIDTH, maxWidth: '100vw' } }}
      >
        <Stack sx={{ height: '100%' }}>
          <Stack
            direction="row"
            sx={{ alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, flexShrink: 0 }}
          >
            <Stack>
              <Typography variant="overline" color="text.secondary" sx={{ lineHeight: 1 }}>
                History
              </Typography>
              <Typography variant="h6">Audit log</Typography>
            </Stack>
            <IconButton onClick={() => setOpen(false)} aria-label="Close audit log" size="small">
              <CloseIcon />
            </IconButton>
          </Stack>
          <Divider />
          <Box
            sx={{ flex: 1, minHeight: 0, overflowY: 'auto', px: 2, py: 1, display: 'flex', flexDirection: 'column' }}
          >
            <AuditHistoryTab targetId={targetId} />
          </Box>
        </Stack>
      </Drawer>
    </>
  )
}

export default AuditLogDrawer
